import React, { useCallback, useEffect, useRef, forwardRef } from 'react'

const DEFAULT_DELAY = 250

const DoubleClick = forwardRef(({
  children,
  onClick,
  onDoubleClick,
  delay = DEFAULT_DELAY,
  ...props
}, ref) => {
  const timerRef = useRef(null)

  const handleClick = useCallback((event) => {
    if (!onDoubleClick) {
      if (onClick) onClick(event)
      return
    }

    if (timerRef.current) {
      clearTimeout(timerRef.current)
      timerRef.current = null
      onDoubleClick(event)
      return
    }

    if (typeof event.persist === 'function') {
      event.persist()
    }

    timerRef.current = setTimeout(() => {
      timerRef.current = null
      if (onClick) onClick(event)
    }, delay)
  }, [delay, onClick, onDoubleClick])

  useEffect(() => () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
  }, [])

  return (
    <div ref={ref} {...props} onClick={handleClick}>
      {children}
    </div>
  )
})

export default DoubleClick
